// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-0d647b13]{font-size:14px}.app-container div[data-v-0d647b13],.app-container ol[data-v-0d647b13],.app-container ul[data-v-0d647b13]{padding:0 20px;text-align:left;line-height:30px}.app-container ol[data-v-0d647b13],.app-container ul[data-v-0d647b13]{list-style:decimal}", ""]);
// Exports
module.exports = exports;
